import { render, staticRenderFns } from "./TransferPrivatPlace.vue?vue&type=template&id=321de1de&"
import script from "./TransferPrivatPlace.vue?vue&type=script&lang=js&"
export * from "./TransferPrivatPlace.vue?vue&type=script&lang=js&"
import style0 from "./TransferPrivatPlace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports